import {h, Fragment} from "preact"
import { colorFacet } from "../../config"

export default function ColorFilter({ identifier, value, selected, count, onChange, className }) {

    return (
        <>
            <input
                id={identifier}
                className="color-filter-input peer input block appearance-none overflow-hidden text-transparent w-5 h-5 rounded-none border cursor-pointer relative checked:before:absolute checked:before:block checked:before:top-[3px] checked:before:left-[3px] checked:before:right-[3px] checked:before:bottom-[3px] checked:border checked:border-black focus:border focus:!border-black hover:!border-black hover:border"
                style={`${
                    (colorFacet[value]?.hex)
                    ? `--filter-color: ${colorFacet[value].hex};`
                    : `background-image: url(${colorFacet[value].url});`
                }`}
                data-color={value}
                type="checkbox" 
                checked={selected}
                onChange={onChange}
                aria-label={selected ? `Remove color filter ${value}` : `Apply color filter ${value}`}
            />
            <label 
                for={identifier}
                class="cursor-pointer peer-checked:font-medium body-2 mt-0.5"
            >
                {value} ({count})
            </label>
        </>
    )
}